import { connect } from 'react-redux';

import * as modal from '../../reducers/modalReducer';
import { invalidateUser } from '../../reducers/userReducer';
import SmallModal from './small_modal';

const mapStateToProps = state => ({
  primaryColor: state.config.primaryColor,
  secondaryColor: state.config.secondaryColor,
});

const mapDispatchToProps = dispatch => ({
  hideModal: () => dispatch(modal.hideModal()),
  invalidate: () => dispatch(invalidateUser()),
});

export default connect(mapStateToProps, mapDispatchToProps)(SmallModal);



// WEBPACK FOOTER //
// ./src/components/SmallModal/small_modal_container.jsx